import type { HTMLAttributes, LegacyRef, ReactNode } from "react";
import { forwardRef } from "react";
import { useObjectRef } from "react-aria";

import { cn, cv, type VariantProps } from "../utils";

export const ncHeadingLevels = {
  1: "text-4xl",
  2: "text-3xl",
  3: "text-2xl",
  4: "text-xl",
  5: "text-lg",
  6: "uppercase",
};

const headingVariants = cv("font-bold", {
  variants: {
    level: ncHeadingLevels,
    styleAs: ncHeadingLevels,
  },
});

export interface NcHeadingProps
  extends HTMLAttributes<HTMLHeadingElement>,
    VariantProps<typeof headingVariants> {
  children: ReactNode;
  level: keyof typeof ncHeadingLevels;
}

export const NcHeading = forwardRef<HTMLAttributes<HTMLHeadingElement>, NcHeadingProps>(
  ({ level, styleAs, className, ...props }, ref) => {
    const objRef = useObjectRef(ref);
    const HeadingTag = `h${level}` as "h1" | "h2" | "h3" | "h4" | "h5" | "h6";

    return (
      <HeadingTag
        data-nc="NcHeading"
        ref={objRef as LegacyRef<HTMLHeadingElement> | undefined}
        className={cn(headingVariants({ level: styleAs || level }), className)}
        {...props}
      />
    );
  }
);
